// Create enums for different types of workers
export var WorkerType;
(function (WorkerType) {
    WorkerType["DECODER_WORKER_BROTLI"] = "DECODER_WORKER_BROTLI";
    WorkerType["DECODER_WORKER"] = "DECODER_WORKER";
})(WorkerType || (WorkerType = {}));
// Worker JS names: 'BinaryDecoderWorker.js', 'DEMWorker.js', 'EptBinaryDecoderWorker.js', 'EptLaszipDecoderWorker.js',
// EptZstandardDecoder_preamble.js', 'EptZstandardDecoderWorker.js', 'LASDecoderWorker.js', 'LASLAZWorker.js', 'LazLoaderWorker.js'
function createWorker(type) {
    switch (type) {
        case WorkerType.DECODER_WORKER_BROTLI: {
            return new Worker(new URL('./brotli-decoder.worker.js', import.meta.url), { type: 'module' });
        }
        case WorkerType.DECODER_WORKER: {
            return new Worker(new URL('./decoder.worker.js', import.meta.url), {
                type: 'module',
            });
        }
        default:
            throw new Error('Unknown worker type');
    }
}
export class WorkerPool {
    // Workers will be an object that has a key for each worker type and the value is an array of Workers that can be empty
    workers = {
        DECODER_WORKER: [],
        DECODER_WORKER_BROTLI: [],
    };
    getWorker(workerType) {
        // Throw error if workerType is not recognized
        if (this.workers[workerType] === undefined) {
            throw new Error('Unknown worker type');
        }
        // Given a worker URL, if URL does not exist in the worker object, create a new array with the URL as a key
        if (this.workers[workerType].length === 0) {
            const worker = createWorker(workerType);
            this.workers[workerType].push(worker);
        }
        const worker = this.workers[workerType].pop();
        if (worker === undefined) {
            // Typescript needs this
            throw new Error('No workers available');
        }
        // Return the last worker in the array and remove it from the array
        return worker;
    }
    returnWorker(workerType, worker) {
        this.workers[workerType].push(worker);
    }
}
